import type { ReactNode } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';

export interface EmptyStateProps {
  icon: ReactNode;
  title: string;
  description: string;
  ctaLabel?: string;
  onCtaClick?: () => void;
  secondaryLabel?: string;
  onSecondaryClick?: () => void;
}

export function EmptyState({
  icon,
  title,
  description,
  ctaLabel,
  onCtaClick,
  secondaryLabel,
  onSecondaryClick,
}: EmptyStateProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        py: 8,
      }}
    >
      <Stack
        alignItems="center"
        spacing={2}
        sx={{ textAlign: 'center', maxWidth: 420 }}
      >
        <Box sx={{ color: 'text.secondary' }}>{icon}</Box>
        <Typography variant="h5" fontWeight="bold">
          {title}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {description}
        </Typography>
        {(ctaLabel || secondaryLabel) && (
          <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
            {ctaLabel && onCtaClick && (
              <Button variant="contained" onClick={onCtaClick}>
                {ctaLabel}
              </Button>
            )}
            {secondaryLabel && onSecondaryClick && (
              <Button variant="outlined" onClick={onSecondaryClick}>
                {secondaryLabel}
              </Button>
            )}
          </Stack>
        )}
      </Stack>
    </Box>
  );
}
